import React from "react";
export default function BoardToolbar({ RoleVisibilityStrip, SelectionActionBar }) {
  return <div className="schedule-board-toolbar">
    {RoleVisibilityStrip && <details className="schedule-roles"><summary>Roles <span aria-hidden="true">⌄</span></summary><RoleVisibilityStrip /></details>}
    {SelectionActionBar && <div className="schedule-selection-actions"><SelectionActionBar /></div>}
  </div>;
}
